import { render, staticRenderFns } from "./SyncStatus.vue?vue&type=template&id=3a22b0e8&scoped=true"
import script from "./SyncStatus.vue?vue&type=script&lang=js"
export * from "./SyncStatus.vue?vue&type=script&lang=js"
import style0 from "./SyncStatus.vue?vue&type=style&index=0&id=3a22b0e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a22b0e8",
  null
  
)

export default component.exports